import { render, staticRenderFns } from "./TableConfigColumnViewV2.vue?vue&type=template&id=f9c8ca2e&"
import script from "./TableConfigColumnViewV2.vue?vue&type=script&lang=js&"
export * from "./TableConfigColumnViewV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports